const urls = {
  websocket: {
    ws: 'ws://www.iotena-web.com/wss',
  },
  login: {
    get_code_image: 'http://lighting.lampmind.com/api/common/get_code_image',/*获取验证码图片*/
    login: 'http://lighting.lampmind.com/api/common/login',/*登陆*/
    logout: 'http://lighting.lampmind.com/api/common/logout',/*退出登陆*/
    getCode: 'http://lighting.lampmind.com/api/common/get_code',/*忘记密码获取邮箱验证码*/
    chargePassword: 'http://lighting.lampmind.com/api/common/charge_password',/*忘记密码设置新密码*/
  },
  // 项目管理
  project: {
    project_nav: 'http://lighting.lampmind.com/api/project/nav', /*项目下拉列表*/
    project_add: 'http://lighting.lampmind.com/api/project/add', /*添加项目*/
    project_update: 'http://lighting.lampmind.com/api/project/update', /*编辑项目*/
    project_del: 'http://lighting.lampmind.com/api/project/del', /*删除项目*/
    project_details: 'http://lighting.lampmind.com/api/project/details', /*获取项目详情*/
    project_uploadImage: 'http://lighting.lampmind.com/api/project/uploadImage', /*上传图片*/
    project_getLockStatus: 'http://lighting.lampmind.com/api/project/getLockStatus', /*获取项目上锁状态*/
    project_setLockStatus: 'http://lighting.lampmind.com/api/project/setLockStatus', /*设置项目上锁状态*/
    project_projectDimming: 'http://lighting.lampmind.com/api/project/projectDimming', /*项目下所有灯控调光*/
    project_consumptionStatistics: 'http://lighting.lampmind.com/api/project/consumptionStatistics', /*耗电量统计*/
    project_deviceTotalStatistics: 'http://lighting.lampmind.com/api/project/deviceTotalStatistics', /*项目设备数量统计*/
    project_outAlarmDeviceToExcel: 'http://lighting.lampmind.com/api/project/outAlarmDeviceToExcel', /*告警设备信息导出excel*/
    project_alarmDeviceList: 'http://lighting.lampmind.com/api/project/alarmDeviceList', /*项目故障设备列表*/
    project_resetProject: 'http://lighting.lampmind.com/api/project/resetProject', /*重置项目信息*/
    project_projectRefresh: 'http://lighting.lampmind.com/api/project/projectRefresh', /*项目下所有设备刷新数据*/
  },
  // 网关管理
  gateway: {
    gateway_nav: 'http://lighting.lampmind.com/api/gateway/nav', /*网关下拉列表*/
    gateway_add: 'http://lighting.lampmind.com/api/gateway/add', /*添加网关*/
    gateway_update: 'http://lighting.lampmind.com/api/gateway/update', /*编辑网关*/
    gateway_del: 'http://lighting.lampmind.com/api/gateway/del', /*删除网关*/
    gateway_details: 'http://lighting.lampmind.com/api/gateway/details', /*网关详情*/
    gateway_gatewayList: 'http://lighting.lampmind.com/api/gateway/gatewayList', /*网关列表*/
    gateway_batchAdd: 'http://lighting.lampmind.com/api/gateway/batchAdd', /*批量添加编辑网关*/
    gateway_configWhiteLists: 'http://lighting.lampmind.com/api/gateway/configWhiteLists', /*组网*/
    searchDevices: 'http://lighting.lampmind.com/api/gateway/searchDevices', /*网关搜索设备*/
    getGatewayWhiteLists: 'http://lighting.lampmind.com/api/gateway/getGatewayWhiteLists', /*获取网关白名单*/
    searchDevicesAndGetLists: 'http://lighting.lampmind.com/api/gateway/searchDevicesAndGetLists', /*搜索未配网设备和获取白名单*/
    saveWhiteLists: 'http://lighting.lampmind.com/api/gateway/saveWhiteLists', /*编辑网关白名单*/
    getWifiInfo: 'http://lighting.lampmind.com/api/gateway/getWifiInfo', /*获取WiFi名称和密码*/
    setWifiInfo: 'http://lighting.lampmind.com/api/gateway/setWifiInfo', /*设置网关名称和密码*/
    addWhiteLists: 'http://lighting.lampmind.com/api/gateway/addWhiteLists', /*设置网关名称和密码*/
  },
  // 灯控管理
  lamp: {
    lamp_nav: 'http://lighting.lampmind.com/api/lamp/nav', /*灯控下拉列表*/
    lamp_add: 'http://lighting.lampmind.com/api/lamp/add', /*添加灯控*/
    lamp_update: 'http://lighting.lampmind.com/api/lamp/update', /*编辑灯控*/
    lamp_del: 'http://lighting.lampmind.com/api/lamp/del', /*删除灯控*/
    lamp_details: 'http://lighting.lampmind.com/api/lamp/details', /*灯控详情*/
    lamp_lampList: 'http://lighting.lampmind.com/api/lamp/lampList', /*灯控列表*/
    lamp_batchAdd: 'http://lighting.lampmind.com/api/lamp/batchAdd', /*批量添加编辑灯控*/
    lamp_updateLocation: 'http://lighting.lampmind.com/api/lamp/updateLocation', /*修改设备位置信息*/
    lamp_sceneNav: 'http://lighting.lampmind.com/api/lamp/sceneNav', /*单灯获取情景下拉*/
    lamp_dimming: 'http://lighting.lampmind.com/api/lamp/dimming', /*单个灯控调光*/
    lamp_setDevStatus: 'http://lighting.lampmind.com/api/lamp/setDevStatus', /*灯控开关灯*/
    lamp_chargeLocation: 'http://lighting.lampmind.com/api/lamp/chargeLocation', /*修改设备经纬度位置信息*/
  },
  // 分组管理
  group: {
    group_nav: 'http://lighting.lampmind.com/api/group/nav', /*分组下拉列表*/
    group_add: 'http://lighting.lampmind.com/api/group/add', /*添加分组*/
    group_update: 'http://lighting.lampmind.com/api/group/update', /*编辑分组*/
    group_del: 'http://lighting.lampmind.com/api/group/del', /*删除分组*/
    group_groupList: 'http://lighting.lampmind.com/api/group/groupList', /*获取分组列表*/
    group_groupDimming: 'http://lighting.lampmind.com/api/group/groupDimming', /*分组中的所有灯控调光*/
    group_groupDetailsList: 'http://lighting.lampmind.com/api/group/groupDetailsList', /*批量获取灯控详情*/

  },
  // 情景管理
  scene: {
    scene_nav: 'http://lighting.lampmind.com/api/scene/nav', /*情景下拉列表*/
    scene_add: 'http://lighting.lampmind.com/api/scene/add', /*添加情景*/
    scene_update: 'http://lighting.lampmind.com/api/scene/update', /*编辑情景*/
    scene_del: 'http://lighting.lampmind.com/api/scene/del', /*删除情景*/
    scene_details: 'http://lighting.lampmind.com/api/scene/details', /*情景详情*/
    scene_list: 'http://lighting.lampmind.com/api/scene/sceneList', /*情景列表*/
    scene_apply: 'http://lighting.lampmind.com/api/scene/sceneApply', /*情景应用*/
    deviceChangeScene: 'http://lighting.lampmind.com/api/scene/deviceChangeScene', /*灯控切换情景*/
  },
  // 日程时间管理
  schedule: {
    schedule_add: 'http://lighting.lampmind.com/api/schedule/add', /*添加日程时间*/
    schedule_update: 'http://lighting.lampmind.com/api/schedule/update', /*编辑日程时间*/
    schedule_del: 'http://lighting.lampmind.com/api/schedule/del', /*删除日程时间*/
    schedule_getCalender: 'http://lighting.lampmind.com/api/schedule/getCalender', /*获取某月的日程事件的日历列表*/
  },
  // 日程时间管理
  map: {
    map_list: 'http://lighting.lampmind.com/api/map/list', /*设备列表*/
  },
  //账户管理
  user: {
    user_list: 'http://lighting.lampmind.com/api/user/list',  /*用户列表*/
    user_add: 'http://lighting.lampmind.com/api/user/add', /*添加账户*/
    user_del: 'http://lighting.lampmind.com/api/user/del', /*删除账户*/
    user_update: 'http://lighting.lampmind.com/api/user/update', /*编辑用户名和密码*/
    user_updateAvatar: 'http://lighting.lampmind.com/api/user/updateAvatar', /*修改用户头像*/
    user_timezoneList: 'http://lighting.lampmind.com/api/user/timezoneList',  /*时区下拉列表*/
    user_updateTimezoneContact: 'http://lighting.lampmind.com/api/user/updateTimezoneContact',  /*修改时区、设备故障联系人及邮箱*/
    user_userDetails: 'http://lighting.lampmind.com/api/user/userDetails',  /*用户信息详情*/
    user_updateSubUser: 'http://lighting.lampmind.com/api/user/updateSubUser', /*编辑子账户*/
    user_getUserSettingInfo: 'http://lighting.lampmind.com/api/user/getUserSettingInfo', /*获取用户设置状态信息*/
    user_setUserSettingInfo: 'http://lighting.lampmind.com/api/user/setUserSettingInfo', /*重置用户设置信息*/
    user_changePwd: 'http://lighting.lampmind.com/api/user/changePwd', /*忘记密码*/
    user_getUserEmail: 'http://lighting.lampmind.com/api/user/getUserEmail', /*忘记密码获取邮箱*/
    user_getEmailCode: 'http://lighting.lampmind.com/api/user/getEmailCode', /*忘记密码获取邮箱验证码*/

  }
}
export default urls